import { useMemo } from 'react'
import { HighlightedItemProps } from '../types'

const HighlightedText = ({ text, highlight }: HighlightedItemProps) => {
  // Memoized constants
  const regex = useMemo(() => new RegExp(`(${highlight})`, 'gi'), [highlight])
  const parts = useMemo(() => text.split(regex), [text, regex])

  if (!highlight?.trim()) {
    return <span>{text}</span>
  }

  return (
    <span>
      {parts.filter((part) => part).map((part, idx) => (regex.test(part) ? <mark key={idx}>{part}</mark> : <span key={idx}>{part}</span>))}
    </span>
  )
}

export default HighlightedText
